
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ErrorHandler } from 'utilities/error';
import { DataHandler } from 'utilities/data';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SummaryType } from 'app/models/summary-type';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  withCredentials: true
};

@Injectable()
export class SummaryTypeService {
    private apiPath = 'api/EDWSummaryType';
    private requestUrl = environment.serviceUrl + this.apiPath;
    constructor(private http: HttpClient) { }

    /**
     * Gets all Summary Types
     * @author Nash Lindley
     */
    getSummaryTypes(): Observable<any> {
        return this.http.get<SummaryType[]>(this.requestUrl, httpOptions).pipe(
            catchError(new ErrorHandler().handleError));
    }

}
